import React from "react";
import "../../styles/Listing.css";
import "../../styles/ChecklistCard.css";
import ChecklistCard from "../../components/ChecklistCard.js";
import importantNotes from "../../data/Saskatchewan/importantNotes.js";
import ImportantNotes from "../../components/ImportantNotes.js";

export default function LetterOfOpinion() {
  const LOIData = [
    "RECO Information Guide Acknowledgement",
    "Representation Agreement - Representation & Service (218)",
    "Copy of Letter of Opinion for services provided (include CMA if applicable)",
  ];

  return (
    <div className="checklists flex flex-col items-center justify-center">
      <ChecklistCard
        province={"SK"}
        Title1={""}
        CheckListData={LOIData}
        Header="Letter Of Opinion"
      />
      <div className="important-notes flex flex-col w-full justify-left pt-6">
        <strong>Important Notes:</strong>

        <ImportantNotes
          Notes={importantNotes.filter(
            (notes) => notes.category.includes("letterOpinion") === true
          )}
        />
      </div>
    </div>
  );
}
